<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
      >
        <el-form-item
          prop="universityId"
          label="学校"
          label-width="100px"
          class="label-strong"
        >
          <el-select
            @change="onUniversityChange"
            v-model="form.universityId"
            placeholder="请选择学校"
          >
            <el-option
              v-for="item in universityList"
              :key="item.Key"
              :label="item.Value"
              :value="item.Key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="advanceEnrollmentCommentList.length > 0"
          prop="advanceEnrollmentComment"
          label="占位备注"
          label-width="100px"
          class="label-strong"
        >
          <el-select
            v-model="form.advanceEnrollmentComment"
            placeholder="请选择占位备注"
          >
            <el-option
              v-for="(item, index) in advanceEnrollmentCommentList"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col
          :span="20"
          :xs="16"
          class="footer-left"
        >
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col
          class="footer-right"
          :span="4"
          :xs="8"
        >
          <el-button
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="save()"
          >确认</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getUniversities, 
  getAdvanceEnrollmentComments } from "../service/common.service";

export default {
  data() {
    return {
      showError: false,
      errorMessage: "",
      submitBtnClass: "primary",
      submitBtnDisable: false,
      universityList: [],
      advanceEnrollmentCommentList:[],
      form: {
        universityId: "",
        advanceEnrollmentComment: ""
      },
      rules: {
        universityId: [
          {
            required: true,
            message:"学校是必须的",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.loadUniversityList();
    this.loadAdvanceEnrollmentCommentList();
  },
  watch: {},
  methods: {
    loadAdvanceEnrollmentCommentList(){
      this.form.advanceEnrollmentComment = "";
      if (!this.form.universityId){
        return;
      }

      getAdvanceEnrollmentComments(this.form.universityId).then(result =>{
        if (result && result.success){
          this.advanceEnrollmentCommentList = result.data;
          this.form.advanceEnrollmentComment = "所有";
        }else{
          this.$message.warning(result.message);
          this.advanceEnrollmentCommentList = [];
        }
      });
    },
    onUniversityChange(){
      this.loadAdvanceEnrollmentCommentList();
    },
    checkAllInputs() {
      let isValid = true;
      this.$refs.form.validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      return isValid;
    },
    close() {
      this.$refs["form"].resetFields();
      this.$emit("close");
    },
    save() {
      let valid = this.checkAllInputs();
      if (!valid) return;
      let university = this.universityList.find(
        i => i.Key == this.form.universityId
      );
      if (!!university) {
        let data = {
          universityId: this.form.universityId,
          universityName: university.Value,
          advanceEnrollmentComment: this.form.advanceEnrollmentComment
        };
        this.$emit("save", data);
      }
    },
    loadUniversityList() {
      getUniversities().then(result => {
        if (!!result && result.success) {
          this.universityList = result.data;
        } else {
          this.universityList = [];
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/selectUniversity.vue